import React from 'react'
import Loader from 'react-loader-spinner'

const LoadingComponent = ({ isVisible }) => {
    return isVisible && (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>

    )
}

export default LoadingComponent